import ColFive from "../../components/FlexView/FlexViewFive/ColFive"
import FlexViewFive from "../../components/FlexView/FlexViewFive/FlexViewFive"
import LinksCard from "../../components/cards/LinksCard"
import Footer from "../../layouts/Footer"
import MainHeader from "../../layouts/MainHeader"
import statementsPageData from "../../data/arabic/subpages/statments-page-data-ar"
import DownloadList from "../../components/Lists/DownloadList"

const StatementsPageAr = () => {
  return (
    <main id="main" className="page">
      <div className="sticky-view">
        <div className="sticky-container">
          <MainHeader 
            title={statementsPageData.title}
            image={{
              src : require("../../assets/images/wallpaper/statements-2.jpg"),
              alt : "Statements and pocilies background"
            }}
          />
        </div>
        <div className="sticky-container-two">
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="wrapper-small">
            <p className="text-paragraph">{statementsPageData.paragraphOne}</p>
            <div className="space-50"></div>
            <div className="space-50"></div>
            {/* <FlexViewFive>
              {statementsPageData.cards.map((item, index) => (
                <ColFive key={index}>
                <LinksCard
                  key={index}
                  title={item.title}
                  image={{
                    src : require(`../../assets/images/cards/${item.image.name}`),
                    alt : item.image.alt,
                  }}
                  links={[item.linkOne]}
                />
                </ColFive>
              ))}
            </FlexViewFive> */}
            <DownloadList data={[
                // {
                //   name : "Compliance with Regulations (PDF )",
                //   path : './'
                // },
                {
                  name : "سياسة المسؤولية الاجتماعية للشركات(PDF)",
                  path : "./Corporate_Social_Responsibility_Policy(ar).pdf"
                },
                // {
                //   name : "Risk Documents(PDF) ",
                //   path : "./",
                // },
                // {
                //   name : "Internal Audit(PDF ) ",
                //   path : "./",
                // },
                // {
                //   name : "Governance And Financial Crime Statements(PDF) ",
                //   path : "./",
                // },
                // {
                //   name : "Codes of Conduct (PDF) ",
                //   path : "./",
                // },
              ]} />
          </div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
)
}

export default StatementsPageAr